module.exports = __webpack_public_path__ + "img/laser-turret-base.5614f809.png";